export class UserWizardModel {

    productList: any;
    selectedProductList: any = [];
    userList: any = [];
    selectedUserList: any = [];
    selectedUsersIds: any = [];
    paginations: any;
    userOffset: number;
    totalUserRecord: number;
    userLimit: number;
    actionType: string;
    source: string;
    user: any;
    product: any;
    previousUrl: string;
    existingProducts: any;
    title: string;
    userEmail: string;
    createUser: boolean;

    constructor() {
        this.productList = undefined;
        this.selectedProductList = undefined;
        this.userList = undefined;
        this.selectedUserList = undefined;
        this.selectedUsersIds = undefined;
        this.paginations = undefined;
        this.actionType = undefined;
        this.source = undefined;
        this.user = undefined;
        this.product = undefined;
        this.previousUrl = undefined;
        this.existingProducts = undefined;
        this.title = undefined;
        this.userEmail = undefined;
        this.createUser = undefined;
    }
};
